import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Usuario } from 'app/domain/usuario';

@Component({
    moduleId: module.id,
    selector: 'sidebar-app',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
})

export class SidebarComponent {

    title = 'sidebar';

    user = new Usuario();

    constructor(private router: Router) {
        this.user.fillFromJSON(window.localStorage.getItem("usuario"));
    }

}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/view/sidebar/sidebar.component.ts